import { CONSTANTS as SHARED_CONSTANTS } from "@theatticusapp/atticus-shared-components";
import Cookies from "js-cookie";
import { AtticusForm } from "models/AtticusForm";

/**
 * Downloads a pdf form.  Replaces downloadJS, which was buggy
 *
 * @param form
 * @returns
 */
export function downloadAtticusForm(estateId: number, userId: number, form: AtticusForm): void {
  const authToken = Cookies.get(SHARED_CONSTANTS.COOKIES.authToken) || "";
  const fileUrl = form.getFilledFormUrl(estateId, userId, authToken);
  if (!fileUrl) {
    console.error("Missing form file url for form " + JSON.stringify(form));
    return;
  }

  // Pretty hacky but does seem to be the way it's done according to various forums
  const fileName = form?.fileName || "download.pdf";
  const link = document.createElement("a");
  link.href = fileUrl + "&for_download=true";
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  console.log("Downloading " + fileUrl + " to " + fileName);
}


/**
 * Downloads a file at a given url.  Replaces downloadJS, which was buggy
 *
 * @param form
 * @returns
 */
export function download(url: string, filename: string): void {
  // Pretty hacky but does seem to be the way it's done according to various forums
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  // link.target = "_blank"
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  console.log("Downloading " + url + " to " + filename);
}